<template>
    <div id="component-chat-log" class="m-8" v-if="chatData && chatData.length>0">
        <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">

            <!-- If previous msg is older than current time -->
            <template v-if="chatData[index-1]">
                <vs-divider v-if="!isSameDay(msg.created_at, chatData[index-1].created_at)" class="msg-time">
                    <span>{{ toDate(msg.created_at) }}</span>
                </vs-divider>
                <div class="spacer mt-8"></div>
            </template>

            <div class="flex items-start " :class="isTicketOwner(msg.agent_name) ? 'flex-row-reverse' : 'flex-row'">

                <template v-if="chatData[index-1]">
                    <template v-if="!isSameDay(msg.created_at, chatData[index-1].created_at)">
                        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0 sm:ml-5 ml-3'">{{senderImg(msg.agent_name)}}</vs-avatar>
                    </template>
                </template>

                <template v-if="index == 0">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0 sm:ml-5 ml-3">{{senderImg(msg.agent_name)}}</vs-avatar>
                </template>

                <template v-if="chatData[index-1]">
                    <div class="mr-16" v-if="!isSameDay(msg.created_at, chatData[index-1].created_at)"></div>
                </template>

                <div  class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm text-white" :class="userBackground(msg.agent_name)">
                    <span>{{ msg.message }}</span>
                    <a v-if="msg.file_path" :href="msg.file_path" target="_blank" style="color:white"> {{ msg.file_path }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return {
            firstLetter: 'A',
        }
    },
    props: ['chatData'],
    computed: {
        activeUserImg() {
            return this.firstLetter;
        },        
    },
    methods: {
        isTicketOwner: function(name){
            return (this.$store.state.AppActiveUser.name===name);
        },
        userBackground: function(name){
            if(this.isTicketOwner(name))
                return 'bg-success-gradient';
            return 'bg-primary-gradient';            
        },
        senderImg: function(val) {
            return val.charAt(0);
        },
        isSameDay(time_to, time_from) {
            const date_time_to = new Date(Date.parse(time_to))
            const date_time_from = new Date(Date.parse(time_from));
            return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate();
        },
        toDate(time) {
            const locale = "en-us";
            const date_obj = new Date(Date.parse(time));
            const monthName= date_obj.toLocaleString(locale, {
                month: 'short'
            });
            return date_obj.getDate() + ' '  + monthName;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
            });
        }
    },
    updated() {
        this.scrollToBottom();
    },
    mounted() {
        this.scrollToBottom();
    }
}
</script>